export const StonesData = {
  tabs: [
    {
      label: 'All Stones',
      id: 1,
    },
  ],
};

export const AdminUserData = {
  tabs: [
    {
      label: 'All Admins',
      id: 1,
    },
  ],
};
